import { motion } from 'framer-motion';
import ListOptions from './ListOptions/ListOptions';
import Ellipse from '../../components/Ellipse/Ellipse';

const Options = () => {
  return (
    <motion.section
      className='options'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Ellipse />
      <div className='options__container grid-fons'>
        <motion.div
          className='options__info'
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          <h2 className='options__title title color'>
            Multiple Payment
            <span className='title'>&nbsp;Options</span>
          </h2>
          <motion.p
            className='options__text subtitle'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 1 }}
          >
            Unleash Global Potential with Local Currency Payments
          </motion.p>
        </motion.div>
        <motion.div
          className='options__inner'
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 1 }}
        >
          <ListOptions className='list-options' />
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Options;
